export default __webpack_public_path__ + "static/media/cr-2.6c9058ed.png";